import React from "react";
import Footer from "../components/Footer";
import "./Features.css";

const Features = () => {
  const features = [
    { icon: "fa-file-pdf", title: "Document Processing", desc: "Upload PDFs, DOCX, TXT files. Our OCR engine extracts text from scanned documents with 99% accuracy.", color: "red" },
    { icon: "fa-globe", title: "Web Scraping", desc: "Import content directly from web URLs. Our scraper extracts clean, structured text from any webpage.", color: "blue" },
    { icon: "fa-brain", title: "Smart Chunking", desc: "Documents are intelligently split into semantic chunks preserving context boundaries and meaning.", color: "purple" },
    { icon: "fa-search", title: "Semantic Search", desc: "Vector embeddings power meaning-based search. Find relevant passages even with different wording.", color: "cyan" },
    { icon: "fa-quote-right", title: "Citation Engine", desc: "Every AI response includes inline citations linking back to exact source passages for verification.", color: "green" },
    { icon: "fa-lock", title: "Enterprise Security", desc: "SOC-2 compliant infrastructure. Your data is encrypted at rest and in transit. Zero data retention.", color: "yellow" },
    { icon: "fa-history", title: "Chat History", desc: "Full conversation history with search. Export chats as PDF or Markdown for documentation.", color: "indigo" },
    { icon: "fa-plug", title: "API Access", desc: "RESTful API for programmatic access. Integrate Contextly AI into your existing workflows and tools.", color: "pink" },
    { icon: "fa-users", title: "Team Collaboration", desc: "Share knowledge bases with your team. Role-based access control and workspace management.", color: "teal" },
  ];

  return (
    <div className="features-page">
      <section className="features-hero">
        <div className="features-badge"><span className="badge-dot"></span> Product Features</div>
        <h1>Everything you need to<br /><span className="gradient-text">chat with your data</span></h1>
        <p>From document ingestion to AI-powered insights, Contextly AI provides a complete RAG platform for your team.</p>
      </section>

      <section className="features-grid-section">
        <div className="features-grid-3">
          {features.map((f, i) => (
            <div key={i} className="feature-item">
              <div className={`feature-item-icon ${f.color}`}><i className={`fa ${f.icon}`}></i></div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Features;
